export default __webpack_public_path__ + "static/media/loader.5bfff1bc.svg";